import * as types from './types';

export const fetchGeolocation = () => dispatch => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(pos => {
      dispatch({
        type: types.CHANGE_MAP_CENTER,
        longitude: pos.coords.longitude,
        latitude: pos.coords.latitude,
      });
    });
  }
};
